function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import axios from 'axios';
// 멘션, 해시태그, 프로젝트 검색 함수들
export var handleUserSearch = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(query, usersQuery) {
        var _usersQuery_data_data_page, _usersQuery_data_data, _usersQuery_data;
        return _ts_generator(this, function(_state) {
            if (!query || query.length < 2) return [
                2,
                []
            ];
            if (!((_usersQuery_data = usersQuery.data) === null || _usersQuery_data === void 0 ? void 0 : (_usersQuery_data_data = _usersQuery_data.data) === null || _usersQuery_data_data === void 0 ? void 0 : (_usersQuery_data_data_page = _usersQuery_data_data.page) === null || _usersQuery_data_data_page === void 0 ? void 0 : _usersQuery_data_data_page.content)) return [
                2,
                []
            ];
            return [
                2,
                usersQuery.data.data.page.content.map(function(user) {
                    return {
                        id: String(user.id || ''),
                        display: user.displayName || '',
                        value: user.username || '',
                        type: 'mention',
                        avatar: user.profileImageUrl || ''
                    };
                })
            ];
        });
    });
    return function handleUserSearch(query, usersQuery) {
        return _ref.apply(this, arguments);
    };
}();
export var handleHashtagSearch = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(query, hashtagsQuery) {
        var _hashtagsQuery_data_data_page, _hashtagsQuery_data_data, _hashtagsQuery_data;
        return _ts_generator(this, function(_state) {
            if (!query || query.length < 2) return [
                2,
                []
            ];
            if (!((_hashtagsQuery_data = hashtagsQuery.data) === null || _hashtagsQuery_data === void 0 ? void 0 : (_hashtagsQuery_data_data = _hashtagsQuery_data.data) === null || _hashtagsQuery_data_data === void 0 ? void 0 : (_hashtagsQuery_data_data_page = _hashtagsQuery_data_data.page) === null || _hashtagsQuery_data_data_page === void 0 ? void 0 : _hashtagsQuery_data_data_page.content)) return [
                2,
                []
            ];
            return [
                2,
                hashtagsQuery.data.data.page.content.map(function(tag) {
                    var _tag_basicInfo;
                    var hashtagName = ((_tag_basicInfo = tag.basicInfo) === null || _tag_basicInfo === void 0 ? void 0 : _tag_basicInfo.tag) || '';
                    return {
                        id: hashtagName,
                        display: "#".concat(hashtagName),
                        value: hashtagName,
                        type: 'hashtag'
                    };
                })
            ];
        });
    });
    return function handleHashtagSearch(query, hashtagsQuery) {
        return _ref.apply(this, arguments);
    };
}();
export var handleProjectSearch = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(query) {
        var _response_data, response, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!query || query.length < 2) return [
                        2,
                        []
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        axios.get('/api/projects/search', {
                            params: {
                                query: query
                            }
                        })
                    ];
                case 2:
                    response = _state.sent();
                    if (!(response === null || response === void 0 ? void 0 : (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.data)) return [
                        2,
                        []
                    ];
                    return [
                        2,
                        response.data.data.map(function(project) {
                            return {
                                id: project.id,
                                display: project.title,
                                value: project.title,
                                type: 'project',
                                metadata: project
                            };
                        })
                    ];
                case 3:
                    error = _state.sent();
                    console.error('프로젝트 검색 오류:', error);
                    return [
                        2,
                        []
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function handleProjectSearch(query) {
        return _ref.apply(this, arguments);
    };
}();
// 토큰 타입에 따른 검색 함수 선택
export var getSuggestions = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(tokenMeta, usersQuery, hashtagsQuery, setIsSearching) {
        var query, results, _;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = tokenMeta.token.slice(1); // @ 또는 # 또는 $ 제거
                    results = [];
                    _ = tokenMeta.type;
                    switch(_){
                        case 'mention':
                            return [
                                3,
                                1
                            ];
                        case 'hashtag':
                            return [
                                3,
                                3
                            ];
                        case 'project':
                            return [
                                3,
                                5
                            ];
                    }
                    return [
                        3,
                        7
                    ];
                case 1:
                    return [
                        4,
                        handleUserSearch(query, usersQuery)
                    ];
                case 2:
                    results = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 3:
                    return [
                        4,
                        handleHashtagSearch(query, hashtagsQuery)
                    ];
                case 4:
                    results = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 5:
                    setIsSearching(true);
                    return [
                        4,
                        handleProjectSearch(query)
                    ];
                case 6:
                    results = _state.sent();
                    setIsSearching(false);
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2,
                        results
                    ];
            }
        });
    });
    return function getSuggestions(tokenMeta, usersQuery, hashtagsQuery, setIsSearching) {
        return _ref.apply(this, arguments);
    };
}();
